/**
 * Container Navigation Store
 *
 * Manages the "enter inside" navigation for Gallery Container nodes.
 * When a user double-clicks a container node, they enter it and see
 * only the nodes that belong to that container. A breadcrumb trail
 * allows navigating back.
 */

import { create } from 'zustand'

interface ContainerNavigationState {
  /** Stack of container IDs — last item is the current container, empty = main canvas */
  stack: string[]

  /** Current container ID (null = main canvas) */
  currentContainerId: string | null

  /** Enter a container */
  enterContainer: (containerId: string) => void

  /** Go back one level */
  goBack: () => void

  /** Go back to main canvas */
  goToRoot: () => void

  /** Reset navigation (e.g., when canvas changes) */
  reset: () => void
}

export const useContainerNavigationStore = create<ContainerNavigationState>((set) => ({
  stack: [],
  currentContainerId: null,

  enterContainer: (containerId: string) => {
    set((state) => {
      const newStack = [...state.stack, containerId]
      return { stack: newStack, currentContainerId: containerId }
    })
  },

  goBack: () => {
    set((state) => {
      const newStack = state.stack.slice(0, -1)
      return {
        stack: newStack,
        currentContainerId: newStack.length > 0 ? newStack[newStack.length - 1] : null,
      }
    })
  },

  goToRoot: () => {
    set({ stack: [], currentContainerId: null })
  },

  reset: () => {
    set({ stack: [], currentContainerId: null })
  },
}))
